import { MobileSignInService } from '../../services/mobile-sign-in.service';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActionsUtilsService } from '@ppl/core';
import { AsyncState } from '@ppl/store';
import { trackById, Unsubscribe } from '@ppl/utils/angular.utils';
import { unsubscribe } from '@ppl/utils/subscription.utils';
import { BehaviorSubject } from 'rxjs';
import type { Subscription } from 'rxjs';
import type { OnInit } from '@angular/core';
import type { MobileSignInSession } from '../../domain/mobile-sign-in';
import type { AsyncValue } from '@ppl/store';

@Component({
  selector: 'ppl-mobile-sign-in-session-list',
  templateUrl: './mobile-sign-in-session-list.component.html',
  styleUrl: './mobile-sign-in-session-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
@Unsubscribe()
export class MobileSignInSessionListComponent implements OnInit {

  @Input() securityToken: string;

  sessions$ = new BehaviorSubject<AsyncValue<MobileSignInSession[]>>({ state: AsyncState.IDLE });

  sessionsSubscription: Subscription;

  trackById = trackById;
  AsyncState = AsyncState;

  constructor(
    private actionsUtilsService: ActionsUtilsService,
    private mobileSignInService: MobileSignInService
  ) { }

  ngOnInit() {
    this.fetchSessions();
  }

  fetchSessions() {
    unsubscribe(this.sessionsSubscription);

    if (this.sessions$.getValue().state !== AsyncState.FETCHED) {
      // Show loading indicator only on first load
      this.sessions$.next({
        state: AsyncState.FETCHING
      });
    }

    this.sessionsSubscription = this.mobileSignInService.fetchSessions().subscribe(
      sessions => {
        this.sessions$.next({
          state: AsyncState.FETCHED,
          value: sessions
        });
      },
      error => {
        this.sessions$.next({
          state: AsyncState.ERROR,
          error
        });
      }
    );
  }

  onSignOutClick(id: number) {
    this.actionsUtilsService.doAction(this.mobileSignInService.deleteSession({
      id,
      securityToken: this.securityToken
    })).subscribe(
      () => {
        this.sessions$.next({
          state: AsyncState.FETCHED,
          value: this.sessions$.getValue().value.filter(session => session.id !== id)
        });
      }
    );
  }

}
